<div class="popup">
  <div class="success-content" *ngIf="success">
      <div class="spec-success-wrapper">
          <p>Черновик корзины успешно создан</p>
          <button class="btn-primary" (click)="goToSpecification()">Открыть черновик</button>
      </div>
  </div>
  <form [formGroup]="inputForm" (ngSubmit)="onSubmit()" aria-labelledby="title" *ngIf="!success">
    <h1>Создать новый черновик корзины</h1>
    <div class="form-content">
      <div class="mb-3">
        <div class="form-control-group">
          <label class="label" i18n="@@Title">Название *</label>
          <input fullWidth nbInput type="text" name="header" formControlName="header" required>
        </div>
      </div>
      <div class="mb-3">
        <div class="form-control-group">
          <label class="label" i18n="@@Description">Описание</label>
          <input fullWidth nbInput type="text" name="description" formControlName="description">
        </div>
      </div>
      <nb-card-footer>
        <button nbButton status="primary"
                size="large"
                type="submit"
                i18n="@@Create"
                [nbSpinner]="submitted" nbSpinnerStatus="control" [disabled]="!inputForm.valid || submitted">
          Создать
        </button>
      </nb-card-footer>
    </div>
  </form>

  <form (ngSubmit)="onSubmitSpecification()" aria-labelledby="title" *ngIf="!success">
    <br><br>
    <h1 i18n="@@CreateSpecification" *ngIf="cartSpecifications.length">Добавить в существующий черновик</h1>
    <div class="form-content">

      <div *ngIf="cartSpecifications.length">
        <div class="form-control-group">
          <p><input nbInput fieldSize="small" fullWidth name="keyword" placeholder="Поиск" [(ngModel)]="keyword" (keyup)="onKey($event)"></p>

          <div *ngIf="cartSpecificationsFiltered.length">
            <div class="popup-table">
              <div class="form-control__item" *ngFor="let item of cartSpecificationsFiltered">
                <nb-checkbox (checkedChange)="toggle($event, item.id)">{{ item.header }}</nb-checkbox>
              </div>
            </div>
          </div>
        </div>
        <nb-card-footer>
          <button nbButton status="primary"
                  size="large"
                  type="submit"
                  i18n="@Add"
                  [nbSpinner]="submitted" nbSpinnerStatus="control" [disabled]="!hasSelected() || submitted">
            Добавить
          </button>
        </nb-card-footer>
      </div>
    </div>
  </form>
</div>
